@if(company){
    <form (ngSubmit)="onSubmit()" class="container p-4">
    
        <!-- LOGO -->
        <div class="mb-3 text-center">
            @if(company.logo){
                <img [src]="company.logo.startsWith('/') ? apiUrl + company.logo : company.logo" alt="Logo" class="rounded-circle mb-2" width="100" height="100">
            } @else {
                <img [src]="'/images/logo/Referio.png'" alt="Logo" class="rounded-circle mb-2" width="100" height="100">
            }
    
            <div>
                <input type="file" class="form-control d-none" #logoInput (change)="onLogoSelected($event)">
                <button type="button" class="btn btn-outline-primary mt-2" (click)="logoInput.click()">
                    <i class="bi bi-image"></i> Modifier le logo
                </button>
            </div>
        </div>
    
        <!-- INFOS ENTREPRISE -->
        <div class="row">
            <div class="col-md-6 mb-3">
                <label class="form-label">Nom de l’entreprise</label>
                <input [(ngModel)]="companyEdit.companyName" name="companyName" class="form-control" required>
            </div>
            <div class="col-md-6 mb-3">
                <label class="form-label">Numéro d’entreprise (ex: BE0123456789)</label>
                <input [(ngModel)]="companyEdit.companyNumber" name="companyNumber" class="form-control">
            </div>
        </div>
    
        <div class="row">
            <div class="col-md-6 mb-3">
                <label class="form-label">Email</label>
                <input type="email" [(ngModel)]="companyEdit.companyEmail" name="companyEmail" class="form-control">
            </div>
            <div class="col-md-6 mb-3">
                <label class="form-label">Téléphone</label>
                <input [(ngModel)]="companyEdit.companyPhoneNumber" name="companyPhoneNumber" class="form-control">
            </div>
        </div>
    
        <!-- ADRESSE -->
        <h5 class="mt-4">Adresse</h5>
    <!--
        <div class="row">
            <div class="col-md-6 mb-3">
                <label class="form-label">Rue</label>
                <input [(ngModel)]="companyEdit.address.street" name="street" class="form-control">
            </div>
            <div class="col-md-6 mb-3">
                <label class="form-label">Numéro</label>
                <input type="number" [(ngModel)]="companyEdit.address.number" name="number" class="form-control">
            </div>
            <div class="col-md-4 mb-3">
                <label class="form-label">Code postal</label>
                <input type="number" [(ngModel)]="companyEdit.address.zipCode" name="zipCode" class="form-control">
            </div>
            <div class="col-md-4 mb-3">
                <label class="form-label">Ville</label>
                <input [(ngModel)]="companyEdit.address.city" name="city" class="form-control">
            </div>
            <div class="col-md-4 mb-3">
                <label class="form-label">Pays</label>
                <input [(ngModel)]="companyEdit.address.country" name="country" class="form-control">
            </div>
        </div>
    -->
        <div class="row">
            <div class="mb-3">                
                <input type="text" id="address" [formControl]="addressCtrl" class="form-control" [placeholder]="companyEdit.address | address">
                @if(suggestions.length){
                    <ul class="list-group mt-1">
                        @for( s of suggestions; track $index ){
                            <li class="list-group-item selectSuggestion" (click)="selectSuggestion(s)">
                            {{ s.place_name }}
                            </li>
                        }
                    </ul>
                }
            </div>
        </div>

        <!-- CATÉGORIE -->
        <div class="mb-3">
            <label class="form-label">Catégorie</label>
            <select [(ngModel)]="companyEdit.category" name="category" class="form-select">
                @for(category of categories; track $index){
                    <option [value]="category">{{category}}</option>
                }
            </select>
        </div>
    
        <!-- DESCRIPTION -->
        <div class="mb-3">
            <label class="form-label">Description</label>
            <textarea [(ngModel)]="companyEdit.description" name="description" rows="3" class="form-control"></textarea>
        </div>
    
        <!-- RÉSEAUX SOCIAUX -->
        <h5 class="mt-4">Réseaux sociaux</h5>
        <div class="mb-3">
            <label class="form-label">Facebook</label>
            <input [(ngModel)]="companyEdit.socialMediaLinks.facebook" name="facebook" class="form-control">
        </div>
        <div class="mb-3">
            <label class="form-label">Instagram</label>
            <input [(ngModel)]="companyEdit.socialMediaLinks.instagram" name="instagram" class="form-control">
        </div>
        <div class="mb-3">
            <label class="form-label">LinkedIn</label>
            <input [(ngModel)]="companyEdit.socialMediaLinks.linkedin" name="linkedin" class="form-control">
        </div>
    
        <!-- GALERIE -->
        <h5 class="mt-4">Galerie</h5>
        <div class="d-flex flex-wrap gap-3 mb-3">
            @for(img of companyEdit.gallery; track $index) {
                <div class="position-relative">
                    <img [src]="img.startsWith('/') ? apiUrl + img : img" alt="gallery" class="rounded shadow-sm" width="120" height="80" style="object-fit:cover;">
                    <button type="button" class="btn btn-sm btn-danger position-absolute top-0 end-0"
                        (click)="removeImage($index)">
                        <i class="bi bi-x"></i>
                    </button>
                </div>
            }
        </div>
        <div class="mb-3">
            <input type="file" class="form-control" (change)="onGalleryImageSelected($event)">
        </div>
    
        <!-- BOUTON SUBMIT -->
        <div class="text-end">
            <a class="btn btn-light mx-3" routerLink="/profile">
                <i class="bi bi-x-circle"></i> annuler
            </a>
            <button type="submit" class="btn btn-primary">
                <i class="bi bi-check-circle"></i> Sauvegarder
            </button>
        </div>
    </form>
}